var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholderWrap"},[_c('img',{attrs:{"src":require("@/assets/img/placeholder.png"),"alt":""}}),_c('p',{staticClass:"emptyTipe"},[_vm._v(_vm._s(_vm.emptyTipe))])])
}
var staticRenderFns = []

export { render, staticRenderFns }